import { useEffect } from "react";

type ScrollStyles = { readonly overflow: string; readonly paddingRight: string };

// Locks `<html>`: the spicy-ui Modal resets both `body.style.overflow` and `body.style.paddingRight` on unmount.
let lockCount = 0;
let previousStyles: ScrollStyles | null = null;

function lockDocumentScroll(): void {
  lockCount += 1;
  if (lockCount > 1) {
    return;
  }

  const rootElement = document.documentElement;
  previousStyles = { overflow: rootElement.style.overflow, paddingRight: rootElement.style.paddingRight };
  const scrollbarWidth = window.innerWidth - rootElement.clientWidth;

  rootElement.style.overflow = "hidden";
  if (scrollbarWidth > 0) {
    rootElement.style.paddingRight = `${scrollbarWidth}px`;
  }
}

function unlockDocumentScroll(): void {
  lockCount -= 1;
  if (lockCount > 0 || previousStyles === null) {
    return;
  }

  const rootElement = document.documentElement;
  rootElement.style.overflow = previousStyles.overflow;
  rootElement.style.paddingRight = previousStyles.paddingRight;
  previousStyles = null;
}

export default function useDocumentScrollLock({ isLocked }: { readonly isLocked: boolean }): void {
  useEffect(() => {
    if (!isLocked) {
      return undefined;
    }

    lockDocumentScroll();
    return unlockDocumentScroll;
  }, [isLocked]);
}
